import React, { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface HeaderMobileProps {
    className?: string;
    children?: ReactNode
}

const HeaderMobile = ({ children, className }: HeaderMobileProps) => {
    return (
        <header className={cn('sticky inset-0 z-10 bg-white max-w-full lg:max-w-[60%] md:max-w-[80%]  m-auto px-6 mb-1', className)}>
            {children}
        </header>
    )
}

export default HeaderMobile
